import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./NavBar.css";
import logo from "./images/spark-logo.png";

export default function NavBar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeItem, setActiveItem] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // check if token exists
    const token = localStorage.getItem("accessToken");
    setIsLoggedIn(!!token);
    
    // التحقق من حالة التمرير عند تغيير الصفحة
    setScrolled(window.scrollY > 50);
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const path = location.pathname;
    setActiveItem(path);
  }, [location]);

  useEffect(() => {
    if (open) {
      document.body.classList.add("menu-open");
      window.scrollTo(0, 0);
    } else {
      document.body.classList.remove("menu-open");
    }
    return () => {
      document.body.classList.remove("menu-open");
    };
  }, [open]);

  const isActive = (path) => activeItem === path;

  useEffect(() => {
    setOpen(false);
  }, [location]);

  return (
    <header className={`nav ${open ? "open" : ""} ${scrolled ? "scrolled" : ""}`}>
      <div className="nav-inner container">
        <Link to="/home">
          <img className="text-uppercase" src={logo} alt="logo" />
        </Link>

        <button
          className={`burger ${open ? "active" : ""}`}
          onClick={() => setOpen(!open)}
          aria-expanded={open}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`menu ${open ? "show" : ""}`}>
          <Link
            to="/home"
            className={`item text-uppercase ${isActive("/home") ? "active" : ""}`}
          >
            Home
          </Link>
          <Link
            to="/about"
            className={`item text-uppercase ${isActive("/about") ? "active" : ""}`}
          >
            About
          </Link>
          <Link
            to="/services"
            className={`item text-uppercase ${isActive("/services") ? "active" : ""}`}
          >
            Services
          </Link>
          <Link
            to="/billboards"
            className={`item text-uppercase ${isActive("/billboards") ? "active" : ""}`}
          >
            Billboards
          </Link>
          <Link
            to="/clintes"
            className={`item text-uppercase ${isActive("/clintes") ? "active" : ""}`}
          >
            Clients
          </Link>
          <Link
            to="/contact"
            className={`item text-uppercase ${isActive("/contact") ? "active" : ""}`}
          >
            GET IN TOUCH
          </Link>

          {/* يظهر بس بعد اللوجين */}
          {isLoggedIn && (
            <Link
              to="/messages"
              className={`item text-uppercase dashboard-link ${
                isActive("/messages") ? "active" : ""
              }`}
            >
              Dashboard
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
}